/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { IUniPickerCategory } from "@/types";
import { IEntity, IFlow, IIntent, IModel, IVersion } from "@chatcaptain/types/chatbot"
import { variables } from "./variables";

export interface IBotState {
  name: string;
  id: string;
  language: string;
  defaultLanguage: string;
  languages: string[];
  flows: IFlow[];
  faqIntents: IIntent[];
  entities: IEntity[] | null;
  languageNames: {[key: string]: string};
  // variables: {[key: string]: IUniPickerCategory};
  picker: {
    variables: {[key: string]: IUniPickerCategory};
  };
  models: IModel[];
  versions: IVersion[];
  liveVersion: number;
  lastVersion: IVersion | null;
}

export const state: IBotState = {
  name: "",
  id: "",
  language: "DE",
  defaultLanguage: "DE",
  languages: ["DE"],
  flows: [],
  faqIntents: [],
  entities: null,
  models: [],
  versions: [],
  lastVersion: null,
  liveVersion: 0,
  languageNames: {
    DE: "Deutsch",
    EN: "Englisch",
    DA: "Dänisch",
    SV: "Schwedisch",
    IT: "Italienisch",
    ES: "Spanisch",
    FR: "Französisch"
  },
  picker: {
    variables: variables
  }
};